import React, { useEffect } from "react"
import MetaTags from 'react-meta-tags';
import Select from 'react-select'

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { useState } from "react";
import { useRef } from "react";
import { postProduct, postUnit } from "helpers/backend_helper";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { Alert } from "reactstrap";
import { getUnits, getProviders } from "helpers/backend_helper";
import BreadcrumbNav from "components/Common/BreadcrumbNav";

const breadcrumbItems = [
  { id:'1', title: 'Catálogos', link: '', active: false },
  { id:'2', title: 'Unidades', link: '/catalogs/units', active: false },
  { id:'3', title: 'Crear', link: '', active: true }
];

const CatalogUnitFormCreate = (props) => {
  const [model, setModel] = useState (props.product)
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState([]);
  const [error, setError] = useState (null)
  const [completed, setCompleted] = useState (null)
  const [btnSaveLoad, setBtnSaveLoad] = useState (false)
  const refForm = useRef('form-user-create')

  // Table Data
  let [color, setColor] = useState("#f46a6a");
  const [loading, setLoading] = useState (false);

  const handleValidSubmit = async (event, values) => {
    setBtnSaveLoad(true)
    try {
      const response = await postUnit({...values, unit_id: selectedUnit})
      setModel(response)
      setError(null)
      setCompleted('Se completo la operación')
      console.log(refForm);
      refForm && refForm.current.reset();
    } catch(error) {
      console.log(error)
      console.log(error.toString())
      setError(error.toString())
      setCompleted(null)
    }
    setBtnSaveLoad(false)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Catalogo de Unidades</title>
        </MetaTags>
        <Container fluid={true}>
          <BreadcrumbNav title="Unidades"  items={breadcrumbItems}/>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                <AvForm
                    ref={refForm}
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    {error ? <Alert color="danger">{error}</Alert> : null}
                    {completed ? <Alert color="success">{completed}</Alert> : null}
                      
                    <div className="mb-3">
                      <AvField
                          name="name"
                          label="Nombre"
                          value=""
                          type="text"
                          required
                          errorMessage="Campo requerido"
                          placeholder=""
                        />
                    </div>
                    <div className="mb-3">
                      <AvField
                          name="description"
                          label="Descripción"
                          value=""
                          type="text"
                          required
                          errorMessage="Campo requerido"
                          placeholder=""
                        />
                    </div>
                    <input name="unit_id" type="hidden" /> 
                    <div className="text-center">
                      <button type="submit" className="btn btn-sm btn-danger w-md" disabled={ btnSaveLoad }>
                        <i className="fas fa-save"></i> Guardar
                      </button>
                      <Link to="/catalogs/units" className="btn w-md btn-sm btn-danger ms-2">
                        <i className="fas fa-reply"></i> Atrás
                      </Link>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

CatalogUnitFormCreate.propTypes = {
  product: PropTypes.object
};

export default CatalogUnitFormCreate
